// apiBase.js
// -----------------------------------------------------------------------------
// v26.17 — Cross-domain CORS workaround.
//
// The Emergent Cloudflare edge (in front of the FastAPI backend) overrides the
// `Access-Control-Allow-Origin` response header with `*` while also emitting
// `Access-Control-Allow-Credentials: true`. Browsers block that combination as
// invalid CORS, so any cross-origin fetch from a domain that isn't the backend
// origin fails silently.
//
// Symptoms: calculators (thermal, corrosivity, carbonation) work when the site
// is served from `durabledesigns.asia` (same-origin as the Emergent backend)
// but fail from `durabledesigns.co.uk`, which is served via a Cloudflare Worker
// reverse-proxy.
//
// Workaround: when the site is served from any of our known production hosts,
// make all API calls SAME-ORIGIN. Relative requests to `/api/*` on `.co.uk`
// hit the Cloudflare Worker, which already forwards upstream to `.asia`. On
// `.asia` and on the Emergent host, same-origin is a no-op.
//
// For preview / localhost / any unknown host, fall back to the build-time
// REACT_APP_BACKEND_URL so nothing changes in dev.
// -----------------------------------------------------------------------------

const PROD_HOSTS = new Set([
  'durabledesigns.asia',
  'www.durabledesigns.asia',
  'durabledesigns.co.uk',
  'www.durabledesigns.co.uk',
  'consulting-hub-38.emergent.host',
]);

export const getApiBase = () => {
  if (typeof window !== 'undefined' && window.location) {
    if (PROD_HOSTS.has(window.location.hostname)) {
      return window.location.origin;
    }
  }
  return process.env.REACT_APP_BACKEND_URL || '';
};
